<template>
  <div>
    <div>
      <PaymentHelpModal
        class="z-100 max-h-full overflow-y-scroll"
        :user="user"
        :is-open="showHelpModal"
        :proveedores="proveedoresPago"
        @modal:close="showHelpModal = false"
      />

      <div class="flex justify-end">
        <button
          v-if="permitePagoElectronico"
          class="inline-flex items-center rounded-full bg-white text-sm font-bold text-blue-brand-700 focus:outline-none"
          title="Ayuda"
          @click="showHelpModal = !showHelpModal"
        >
          <OutlineQuestionMarkCircleIcon class="h-6 w-6" />
        </button>
      </div>
      <div class="space-y-4">
        <SeleccionModoPago
          ref="mediosPago"
          :monto="datosFormulario.values.importe"
          :tipoDeuda="formulario.tipoDeuda"
          v-model="medioPago"
          @mediosHabilitados:change="algunMedioHabilitado = $event"
          @permitePagoElectronico:update="permitePagoElectronico = $event"
          @permitePagarMasTarde:update="permitePagarMasTarde = $event"
        />
        <div class="flex flex-row-reverse">
          <NextStepButton :valid="medioPago != null" @click.native="onConfirm"
            >Confirmar y generar pago</NextStepButton
          >
          <button
            v-if="permitePagarMasTarde"
            class="mx-2 rounded-md border px-4 py-2 text-sm font-medium uppercase tracking-wide shadow-sm"
            :class="
              algunMedioHabilitado
                ? 'border-gray-300 bg-white text-gray-700 transition duration-150 ease-in-out hover:bg-cool-gray-200 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-cool-gray-200'
                : 'cursor-not-allowed border-gray-200 bg-gray-100 text-gray-400'
            "
            :disabled="!algunMedioHabilitado"
            @click="pagarMasTarde"
          >
            Pagar más tarde
          </button>
        </div>
      </div>
    </div>
    <ConfirmarPagoModal
      :isOpen="showConfirmModal"
      :medioPago="medioPago"
      @modal:confirm="afterCreation"
      @modal:cancel="showConfirmModal = false"
    />
  </div>
</template>

<script>
import { useSession } from '@colescba/ui'

import { mapState, mapActions, mapGetters } from 'vuex'
import { proveedoresPagoDefault, proveedorParagraphs } from '@colescba/ui'
import ConfirmarPagoModal from '@/components/Formularios/ConfirmarPagoModal.vue'
import SeleccionModoPago from '@/components/SeleccionModoPago'

export default {
  components: { ConfirmarPagoModal, SeleccionModoPago },

  mixins: [useSession()],

  data() {
    return {
      medioPago: null,
      showConfirmModal: false,
      showHelpModal: false,
      proveedoresPago: null,
      algunMedioHabilitado: false,
      permitePagoElectronico: false,
      permitePagarMasTarde: false,
    }
  },

  beforeMount() {
    this.proveedoresPago = proveedoresPagoDefault

    this.proveedoresPago.BANELCO.paragraphs.lines = proveedorParagraphs(
      this.formulario.pagoElectronico.BANELCO.rubro,
      this.formulario.pagoElectronico.BANELCO.ente,
      this.formulario.pagoElectronico.BANELCO.campoCPE
    )

    this.proveedoresPago.LINK.paragraphs.lines = proveedorParagraphs(
      this.formulario.pagoElectronico.LINK.rubro,
      this.formulario.pagoElectronico.LINK.ente,
      this.formulario.pagoElectronico.LINK.campoCPE
    )
  },

  computed: {
    ...mapState({
      currentStep: state => state.stepper.currentStep,
      formulario: state => state.stepper.formulario,
    }),
    ...mapGetters({
      datosFormulario: 'stepper/datosFormulario',
    }),
  },

  methods: {
    ...mapActions({
      altaDeuda: 'stepper/altaDeuda',
    }),

    onConfirm() {
      this.showConfirmModal = true
    },

    pagarMasTarde() {
      this.medioPago = null
      this.showConfirmModal = true
    },

    afterCreation() {
      this.showConfirmModal = false
      this.$toast.open({
        message: 'Comprobante generado correctamente.',
        type: 'success',
        duration: 2500,
        dismissible: true,
      })
      this.$router.push({ name: 'comprobantes' })
    },
  },

  watch: {
    showHelpModal(newValue, oldValue) {
      if (newValue) {
        document.querySelector('body').classList.add('overflow-y-hidden')
      } else {
        document.querySelector('body').classList.remove('overflow-y-hidden')
      }
    },
  },

  beforeDestroy() {
    document.querySelector('body').classList.remove('overflow-y-hidden')
  },
}
</script>
